function initialState () {
  return {
    apiError: false,
    errorResponse: ''
  }
}

const state = initialState()


const actions = {
  hasApiError ({ commit }) {
    commit('hasApiError')
  },
  clearApiError ({ commit }) {
    commit('clearApiError')
  },
  setApiErrorResponse (context, resp) {
    context.commit('setApiErrorResponse', resp)
  },
  clearApiErrorResponse ({ commit }) {
    commit('clearApiErrorResponse')
  },
  resetAPI ({ commit }) {
    commit('resetAPI')
  }
}

const mutations = {
  resetAPI (state) {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  hasApiError (state) {
    state.apiError = true
  },
  clearApiError (state) {
    state.apiError = false
  },
  setApiErrorResponse (state, resp) {
    state.errorResponse = resp
  },
  clearApiErrorResponse (state) {
    state.errorResponse = ''
  }
}

export default {
  state,
  actions,
  mutations
}
